import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Healthaddonexclusive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.healthaddonexclusive_Id,
          sortable: true,
          cell: (row) => <span>{row.healthaddonexclusive_Id}</span>,
        },
        { name: "insurer name", selector: (row, i) => row.insurername, sortable: true, cell: (row) => <span>{row.insurername}</span>, }, { name: "product name", selector: (row, i) => row.productname, sortable: true, cell: (row) => <span>{row.productname}</span>, }, { name: "product code", selector: (row, i) => row.productcode, sortable: true, cell: (row) => <span>{row.productcode}</span>, }, { name: "product id", selector: (row, i) => row.productid, sortable: true, cell: (row) => <span>{row.productid}</span>, }, { name: "addons code one", selector: (row, i) => row.addonscodeone, sortable: true, cell: (row) => <span>{row.addonscodeone}</span>, }, { name: "addons code two", selector: (row, i) => row.addonscodetwo, sortable: true, cell: (row) => <span>{row.addonscodetwo}</span>, }, { name: "dummy one", selector: (row, i) => row.dummyone, sortable: true, cell: (row) => <span>{row.dummyone}</span>, }, { name: "dummy two", selector: (row, i) => row.dummytwo, sortable: true, cell: (row) => <span>{row.dummytwo}</span>, }, { name: "dummy three", selector: (row, i) => row.dummythree, sortable: true, cell: (row) => <span>{row.dummythree}</span>, },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={this.handleOffcanvasShow}
                className="bi bi-pen" style={{ "marginRight": "3px" }}
              >

              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >

              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      insurername: '', productname: '', productcode: '', productid: '', addonscodeone: '', addonscodetwo: '', dummyone: '', dummytwo: '', dummythree: '',
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  HealthaddonexclusiveeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Healthaddonexclusive_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);

  }

  HealthaddonexclusivefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Healthaddonexclusive/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  HealthaddonexclusivesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('insurername', this.state.insurername);
    formData.append('productname', this.state.productname);
    formData.append('productcode', this.state.productcode);
    formData.append('productid', this.state.productid);
    formData.append('addonscodeone', this.state.addonscodeone);
    formData.append('addonscodetwo', this.state.addonscodetwo);
    formData.append('dummyone', this.state.dummyone);
    formData.append('dummytwo', this.state.dummytwo);
    formData.append('dummythree', this.state.dummythree);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Healthaddonexclusive/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthaddonexclusivefetchHandler();
          this.handleOffcanvasClose();
          this.setState({ insurername: '', productname: '', productcode: '', productid: '', addonscodeone: '', addonscodetwo: '', dummyone: '', dummytwo: '', dummythree: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  HealthaddonexclusiveupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('insurername', this.state.insurername);
    formData.append('productname', this.state.productname);
    formData.append('productcode', this.state.productcode);
    formData.append('productid', this.state.productid);
    formData.append('addonscodeone', this.state.addonscodeone);
    formData.append('addonscodetwo', this.state.addonscodetwo);
    formData.append('dummyone', this.state.dummyone);
    formData.append('dummytwo', this.state.dummytwo);
    formData.append('dummythree', this.state.dummythree);


    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Healthaddonexclusive/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthaddonexclusivefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.HealthaddonexclusivefetchHandler();

  }
  handleinsurernameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ insurername: fieldValue });
  }; handleproductnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productname: fieldValue });
  }; handleproductcodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productcode: fieldValue });
  }; handleproductidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productid: fieldValue });
  }; handleaddonscodeoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ addonscodeone: fieldValue });
  }; handleaddonscodetwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ addonscodetwo: fieldValue });
  }; handledummyoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyone: fieldValue });
  }; handledummytwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummytwo: fieldValue });
  }; handledummythreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummythree: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('healthaddonexclusive_Id', row.healthaddonexclusive_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Healthaddonexclusive/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthaddonexclusivefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="title_left">
            <h2 style={{ textAlign: "start" }}>Health addon exclusive</h2>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                                   dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Healthaddonexclusive page</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>insurer name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleinsurernameChange} className="form-control" name="insurername" value={this.state.insurername} required="required" placeholder="Enter insurername" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.insurername} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>product name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductnameChange} className="form-control" name="productname" value={this.state.productname} required="required" placeholder="Enter productname" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productname} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>product code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductcodeChange} className="form-control" name="productcode" value={this.state.productcode} required="required" placeholder="Enter productcode" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productcode} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>product id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleproductidChange} className="form-control" name="productid" value={this.state.productid} required="required" placeholder="Enter productid" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.productid} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>addons code one</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleaddonscodeoneChange} className="form-control" name="addonscodeone" value={this.state.addonscodeone} required="required" placeholder="Enter addonscodeone" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.addonscodeone} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>addons code two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleaddonscodetwoChange} className="form-control" name="addonscodetwo" value={this.state.addonscodetwo} required="required" placeholder="Enter addonscodetwo" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.addonscodetwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>dummy one</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyoneChange} className="form-control" name="dummyone" value={this.state.dummyone} required="required" placeholder="Enter dummyone" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyone} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>dummy two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummytwoChange} className="form-control" name="dummytwo" value={this.state.dummytwo} required="required" placeholder="Enter dummytwo" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummytwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>dummy three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummythreeChange} className="form-control" name="dummythree" value={this.state.dummythree} required="required" placeholder="Enter dummythree" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummythree} </div>
                                  </Row><br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.HealthaddonexclusivesubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 60, 70, 80, 90, 100]}
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
